import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
  STR_LATEST_ARTICLES,
  STR_MENU_ARTICLES,
  STR_MENU_STORIES,
  STR_MENU_UTILITIES,
  STR_MORE_ARTICLES,
  STR_NO_MESSAGES
} from "../Strings";
import OneChatRoom from '../ones/OneChatRoom';
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);



  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getMyChatRooms();
    setReady(true);
  }


  useEffect(() => {
    init();
  }, [])


  if (ready) {
    if (appContext.currentUserData.subscriptionStatus === 'active') {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "scroll",
            paddingTop: "20px",
            paddingBottom: "40px",
          }}
          className="mNoScrollBar"
        >
          <div className="container">
  
            {
              (appContext.myChatRooms && appContext.myChatRooms.length > 0) ?
                appContext.myChatRooms.map((item, i) => {
                  return (
                    <OneChatRoom key={i} data={item} />
                  )
                })
                :
                <h6
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {STR_NO_MESSAGES[appContext.language]}
                </h6>
            }
  
          </div>
  
  
        </div>
      )
    } else {
      return (
        <div className="container">
          <SubscriptionExpiredWidget />
        </div>
      )
    }

  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}